import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currency: "",
  weight: "",
  distance: "",
  timezone: "",
  dateFormat: "",
  taxLabel: "Tax",
};

export const userSettingsSlice = createSlice({
  name: "userSettings",
  initialState,
  reducers: {
    setUserSettings: (state, action) => {
      const { currency, weight, distance, timezone, date_format, tax_label } = action.payload;

      state.currency = currency;
      state.weight = weight;
      state.distance = distance;
      state.timezone = timezone;
      state.dateFormat = date_format;
      state.taxLabel = tax_label || "Tax";
    },
    setUserTimezone: (state, action) => {
      state.timezone = action.payload;
    },
    setDateFormat: (state, action) => {
      state.dateFormat = action.payload;
    },
    resetUserSettings: () => initialState,
  },
});

export const { setUserSettings, setUserTimezone, setDateFormat, resetUserSettings } = userSettingsSlice.actions;

export default userSettingsSlice.reducer;
